"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPopup = function IconPopup(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: "25",
    height: "25",
    viewBox: "0 0 38 30",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.0909 2H4.90909C3.30244 2 2 3.30244 2 4.90909V22.3636C2 23.9703 3.30244 25.2727 4.90909 25.2727H31.0909C32.6976 25.2727 34 23.9703 34 22.3636V4.90909C34 3.30244 32.6976 2 31.0909 2Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 10.728H34",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

IconPopup.defaultProps = {
  color: 'black',
  size: 25
};
IconPopup.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconPopup;
exports.default = _default;